VjsAdmin.User = (function () {
    function showAjaxError($modal, msg, error) {
        const $body = $('<div>');
        $body.append($('<p>').text(msg));
        $body.append(SafeDOM.makeAlertDiv('Error ' + error.status + ': ' + error.statusText, 'danger'));
        $modal.find('.modal-body').empty().append($body.children());
    }

    const init = function () {
        $('.resend-validation-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            const $modal = VjsAdmin.Modal.create({
                title: 'Resending Validation Email',
                body: '<i class="fa fa-refresh fa-spin fa-fw"></i>',
                footer: '<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>',
            });
            $modal.modal();

            $.get(href, () => {
                $modal.find('.modal-body').html('<p>Validation email has been sent!</p>');
            }).fail((error) => {
                showAjaxError($modal, 'An error occurred while resending the validation email.', error);
            });
            return false;
        });

        $('.login-as-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            const $modal = VjsAdmin.Modal.create({
                title: 'Log in as User',
                body: '<i class="fa fa-refresh fa-spin fa-fw"></i>',
                footer: '<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>',
            });
            $modal.modal();

            $.get(href, (data) => {
                const safeUrl = SafeDOM.validatePlatformUrl(data.data.url);
                if (safeUrl === null) {
                    console.error('login-as: rejected unsafe URL', data.data.url);
                    $modal.find('.modal-body').empty();
                    return;
                }
                const $body = $('<div>');
                $body.append(
                    $('<p>').html('<strong>Right-click</strong> this link and choose the <strong>"Open Link in Incognito Window"</strong> option:'),
                );
                $body.append(
                    $('<p>').addClass('text-center').append(
                        $('<a>').attr('href', safeUrl).text(safeUrl),
                    ),
                );
                $modal.find('.modal-body').empty().append($body.children());
            }).fail((error) => {
                showAjaxError($modal, 'An error occurred while retrieving the login link.', error);
            });
            return false;
        });

        $('.user-logout-link').on('click', function (e) {
            e.preventDefault();
            if (!window.confirm('Are you sure you want to logout the user?')) return false;

            const $self = $(this);
            const href = $self.attr('href');

            $.post(href, {}, () => {
                $self.html("<i class='fa fa-check'></i> Logout"); // noaikido — static string literal, no interpolation
                setTimeout(() => {
                    $self.text('Logout');
                }, 2000);
            }).fail(() => {
                window.alert('There was a problem logging out user.');
            });

            return false;
        });

        $('.change-password-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const form = $('<div>').html($('#change-password-template').html());
            const submitButton = $('<button type="button" class="btn btn-green">Change Password</button>');
            const closeButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>');

            $(submitButton).on('click', (ee) => {
                ee.preventDefault();

                $modal.find('.modal-footer button').prop('disabled', true).html('Working... <i class="fa fa-spinner fa-pulse fa-fw"></i>'); // noaikido — static string literal, no interpolation

                $('body').css('cursor', 'wait');

                $.post(href, $(form).find('form').serialize(), () => {
                    $modal
                        .find('.modal-body')
                        .html(
                            '<div class="alert alert-success" role="alert"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Password Changed!</div>',
                        );
                    $modal.find('.modal-footer button').replaceWith(closeButton);
                }).fail((error) => {
                    $modal.find('.modal-body .alert').remove();
                    $modal
                        .find('.modal-body')
                        .prepend(SafeDOM.makeAlertDiv('Error: ' + error.responseJSON.message, 'danger'));
                    $modal.find('.modal-footer button').html('Change Password').prop('disabled', false);
                    $('body').css('cursor', 'default');
                });
            });

            const $modal = VjsAdmin.Modal.create({
                title: 'Change Password',
                body: form,
                footer: submitButton,
            });
            $modal.modal();

            return false;
        });
    };

    return {
        init,
    };
}());
